"use client";

import React from "react";
import SectionLayout from "../ui/SectionLayout";
import FlexSectionRow from "../ui/FlexSectionRow";
import FlexSectionTile from "../ui/FlexSectionTile";
import { SectionProps } from "./model";
import { getDefaultCmsSection } from "@/utils/helper";

const FlexSectionComponent: React.FC<
  SectionProps<{
    visning: string;
    forceShowAll?: boolean;
    items: {
      prioritet: string;
      imgurl: string;
      overskrift: string;
      tekst: string;
      link: string;
      linktext: string;
    }[];
  }>
> = ({ cmsSection }) => {
  const listType = cmsSection.specifics.visning || "Liste";

  return (
    <SectionLayout cmsSection={getDefaultCmsSection(cmsSection)}>
      {listType === "Liste" && (
        <div className="flex flex-col gap-4 md:gap-10">
          {cmsSection.specifics.items.map((item, index) => (
            <FlexSectionRow
              forceShowAll={cmsSection.specifics?.forceShowAll}
              key={index}
              item={item}
            />
          ))}
        </div>
      )}
      {listType === "Galleri" && (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-10">
          {cmsSection.specifics.items.map((item, index) => (
            <FlexSectionTile
              forceShowAll={cmsSection.specifics?.forceShowAll}
              key={index}
              item={item}
            />
          ))}
        </div>
      )}
    </SectionLayout>
  );
};

export default FlexSectionComponent;
